import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { endpoints, asset } from "../lib/api";
import { openBookingModal } from "../lib/bookingModal";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";

export default function Rooms() {
  const [rooms, setRooms] = useState([]);
  useEffect(() => { endpoints.rooms().then(setRooms).catch(() => {}); }, []);

  return (
    <div>
      <PageHero overline="Accommodation" title="Our Rooms"
        subtitle="Thirty-six ground-floor rooms, each with parking at the door and every comfort of home."
        image="/static/generated/byer-room-single.png" />

      <section className="bg-[#F7F5F0] py-24" data-testid="rooms-list">
        <div className="max-w-7xl mx-auto px-5 md:px-8 space-y-20">
          {rooms.map((r, i) => (
            <Reveal key={r.id}>
              <div className={`grid md:grid-cols-2 gap-10 items-center ${i % 2 ? "md:[direction:rtl]" : ""}`} data-testid={`room-${r.slug}`}>
                <div className="[direction:ltr] rounded-2xl overflow-hidden soft-shadow group">
                  <img src={asset(r.image)} alt={r.name} className="w-full h-[360px] object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
                </div>
                <div className="[direction:ltr]">
                  <p className="overline text-[#D4AF37] mb-2">{r.tagline} · {r.capacity}</p>
                  <h2 className="font-serif text-4xl md:text-5xl text-[#0B192C]">{r.name}</h2>
                  <p className="text-[#222]/70 mt-4 font-light leading-relaxed">{r.description}</p>
                  <p className="text-sm text-[#0B192C] mt-4 font-medium">{r.beds}</p>
                  <div className="grid grid-cols-2 gap-2.5 mt-6">
                    {r.amenities?.map((a) => (
                      <span key={a} className="flex items-center gap-2 text-sm text-[#222]/70">
                        <Check size={15} className="text-[#D4AF37] shrink-0" /> {a}
                      </span>
                    ))}
                  </div>
                  <button onClick={() => openBookingModal()} data-testid={`book-${r.slug}`}
                    className="mt-8 bg-[#0B192C] text-white px-8 py-3.5 rounded-full font-medium hover:bg-[#D4AF37] hover:text-[#0B192C] transition-colors">
                    Book {r.name}
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
